import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar'; // Import your Navbar component
import logo from '../assets/images/logo-2.png';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    console.error(isMenuOpen);
  };
  return (
    <header className=" z-2">

      {/* Main Menu Area */}
      <div className=" header-nav-menu" id="header-nav-menu">
        <div className="container" >
          <div className="header-nav-menu-inner py-4">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-2 col-md-3 col-5">
                <div className="navbar-logo m-0">
                  <Link to="/"><img src={logo} alt="logo" className="w-80 d-block" /></Link>
                </div>
              </div>
              <div className="col-2 d-lg-none text-end">
                <div id="slicknav-mobile">
                  <div className={`slicknav_menu ${isMenuOpen ? 'slicknav_open' : ''}`}>
                    <button
                      onClick={toggleMenu}
                      className={`slicknav_btn ${isMenuOpen ? 'slicknav_open' : 'slicknav_collapsed'}`}
                      style={{ background: 'transparent', border: 'none', outline: 'none' }}
                    >
                      {/* The 4 lines icon defined in your CSS */}
                      <span className="slicknav_icon">
                        <span className="slicknav_icon-bar"></span>
                        <span className="slicknav_icon-bar"></span>
                        <span className="slicknav_icon-bar"></span>
                        <span className="slicknav_icon-bar"></span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className={`navbar-collapse ${isMenuOpen ? 'd-block slicknav_nav' : 'd-none d-lg-block'}`}>
                  <Navbar />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;